import { createContext, useContext, type ReactNode } from 'react';
import { EMPTY_PRICE_BREAKDOWN, type PriceBreakdown } from './types';

const PriceContext = createContext<PriceBreakdown>(EMPTY_PRICE_BREAKDOWN);

export function PriceProvider({
    value,
    children,
}: {
    value: PriceBreakdown;
    children: ReactNode;
}) {
    return <PriceContext.Provider value={value}>{children}</PriceContext.Provider>;
}

/** Full breakdown with per-line details — used by the SummaryPanel. */
export function usePriceBreakdown(): PriceBreakdown {
    return useContext(PriceContext);
}

/** Just the running total — used by the BottomBar. */
export function useTotalPrice(): number {
    return useContext(PriceContext).total;
}
